import Button from "@mui/joy/Button";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Tables } from "../../supabase/supabase";
import Scoreboard from "./Scoreboard";

interface TriviaFinishProps {
  playAgain: () => void;
  score: number;
  todayTriviaScores: Tables<'triviaScores'>[];
  allTimeTriviaScores: Tables<'triviaScores'>[];
  userId: number;
}

export default function TriviaFinish({ playAgain, score, todayTriviaScores, allTimeTriviaScores, userId }: TriviaFinishProps) {
  const navigate = useNavigate();

  return (
    <div className="h-full flex flex-col items-center justify-center gap-2 text-blue-600 p-4">
      <div className="text-xl font-bold mb-4 text-center">
        <span>{scoreTextMapping[score].premessage} you scored</span>
        <br />
        <span className="text-4xl">{score}</span><span>{score === 1 ? " point" : " points"}! </span>
        <br />
        <span>{scoreTextMapping[score].postmessage}</span>
      </div>

      <Scoreboard todayTriviaScores={todayTriviaScores} allTimeTriviaScores={allTimeTriviaScores} userId={userId} />

      <div className="text-2xl font-bold mb-4 text-center">
        Think you can do better? Try again to answer new questions!
      </div>

      <div className="w-full flex flex-row justify-around">
        <Button
          onClick={() => {
            navigate("/");
          }}
          size="lg"
          variant="soft"
        >
          Explore the site
        </Button>

        <Button
          onClick={() => {
            playAgain();
          }}
          size="lg"
          variant="solid"
        >
          Play again
        </Button>
      </div>
    </div>
  );
}

const scoreTextMapping: { [key: number]: { premessage: string; postmessage: string } } = {
  0: {
    premessage: "wow...",
    postmessage: "Sorry, but you might not get a card next year...",
  },
  1: {
    premessage: "Oof,",
    postmessage: "How did you get on the mailing list?",
  }, 
  2: {
    premessage: "Yikes,",
    postmessage: "*One* of us must like you a lot.",
  }, 
  3: {
    premessage: "Okay,",
    postmessage: "Plenty of room for improvement...",
  }, 
  4: {
    premessage: "Not bad,",
    postmessage: "We should probably spend more time together this year.",
  }, 
  5: {
    premessage: "Decent,",
    postmessage: "5 rounds up to 10, right?",
  }, 
  6: {
    premessage: "Solid,",
    postmessage: "You're welcome at our place any time!",
  }, 
  7: {
    premessage: "Impressive,",
    postmessage: "Thanks for being a great friend!",
  }, 
  8: {
    premessage: "Great work,",
    postmessage: "You made the short list to be our next roommate!",
  }, 
  9: {
    premessage: "Congratulations,",
    postmessage: "Hope it's enough to stay on the leaderboard!",
  }, 
  10: {
    premessage: "WOW,",
    postmessage: "You're an honorary Amigo now!",
  },
}